if (!customElements.get("offer-component")) {
  class OfferComponent extends HTMLElement {
    constructor() {
      super();

      this.upsell = this.dataset.upsell;
      this.upsell_modal = this.dataset.upsellModal;

      this.btn = this.querySelector("#add-to-cart");
      this.btnOneTime = this.querySelector("#add-to-cart-one-time");
      this.form = document.querySelector(
        `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
      );
      this.offers = this.form.querySelectorAll(".ps-offer-offers__item");
      this.gifts = this.form.querySelectorAll(".ps-offer-gifts__item");
      this.giftsSection = this.form.querySelector(".ps-offer-gifts");
      this.idInput = this.form.querySelector('input[name="id"]');
      this.sellingPlans = this.form.querySelectorAll(".product-selling-plans");
      this.klarnaBlocks = this.querySelectorAll(".product-klarna");
      this.rechargeContainer = this.form.querySelector(
        ".ps-offer__product-recharge",
      );
      this.footer = this.form.querySelector(".ps-offer__footer");
      this.ps_source = window.location.pathname;
      this.init();
    }
    init() {
      this.btn.addEventListener("click", (e) => this.onAddToCart(e));
      if (this.btnOneTime != null)
        this.btnOneTime.addEventListener("click", (e) =>
          this.onAddToCartOneTime(e),
        );
      /// If no idInput, we are showing the vertical offers display
      if (this.idInput) {
        this.idInput.addEventListener("change", (e) => this.onVariantChange(e));

        if (this.dataset.defaultOffer == "true") this.checkSpecialOffers();
        // This is for when having multiple gifts
        this.checkGiftsCheckboxes();
      }

      if (this.form.querySelector("product-radios"))
        this.form
          .querySelector("product-radios")
          .addEventListener("variantChange", (e) => {
            this.updateSingleGiftSection();
            this.updateSellingPlansVisibility(e.detail.selectedOption);
            this.updateKlarnaVisibility(e.detail.selectedOption);
          });

      // This is for when having a single gift
      if (this.form.querySelector(".ps-offer-gifts--no-selection")) {
        this.form.querySelectorAll("input[name=offers]").forEach((item) => {
          item.addEventListener("change", (e) =>
            this.updateSingleGiftSection(),
          );
        });

        this.updateSingleGiftSection();
      }
    }

    titleChangedUnsubscriber = undefined;
    variantChangedUnsubscriber = undefined;

    onVariantChange(e) {
      if (this.idInput) {
        if (this.dataset.defaultOffer == "true") this.checkSpecialOffers();
        this.checkGiftsCheckboxes();
      }

      if (this.form.querySelector(".ps-offer-gifts--no-selection"))
        this.updateSingleGiftSection();
    }

    checkSpecialOffers() {
      this.offers.forEach((offerItem) => {
        offerItem.classList.remove("ps-offer-offers__item--disabled");
        offerItem.querySelector("input").removeAttribute("disabled");
        offerItem.querySelector("input").checked = false;

        if (
          offerItem.dataset.excludeProductSelectedVariant.includes(
            this.idInput.value,
          )
        ) {
          offerItem.classList.add("ps-offer-offers__item--disabled");
          offerItem.querySelector("input").setAttribute("disabled", true);
          offerItem.querySelector("input").checked = false;
        }
      });

      if (
        this.form.querySelector(
          ".ps-offer-offers__item:not(.ps-offer-offers__item--disabled)",
        )
      )
        this.form
          .querySelector(
            ".ps-offer-offers__item:not(.ps-offer-offers__item--disabled)",
          )
          .querySelector("input").checked = true;
    }

    checkGiftsCheckboxes() {
      // Enabeld/disabled gift depending on main product variant selection
      this.gifts.forEach((giftItem) => {
        giftItem.classList.remove("ps-offer-gifts__item--disabled");
        const giftInput = giftItem.querySelector("input");
        if (giftInput) {
          giftInput.removeAttribute("disabled");
          giftInput.checked = false;
        }

        if (
          giftItem.dataset.excludeProductSelectedVariant.includes(
            this.idInput.value,
          )
        ) {
          giftItem.classList.add("ps-offer-gifts__item--disabled");
          if (giftInput) {
            giftInput.setAttribute("disabled", true);
          }
        }
      });

      if (
        this.form.querySelectorAll(
          ".ps-offer-gifts__item:not(.ps-offer-gifts__item--disabled)",
        ).length >= 1
      ) {
        this.form.querySelector(".ps-offer-gifts")?.classList.remove("hidden");
        if (
          this.form
            .querySelector(
              ".ps-offer-gifts__item:not(.ps-offer-offers__item--disabled)",
            )
            .querySelector("input")
        )
          this.form
            .querySelector(
              ".ps-offer-gifts__item:not(.ps-offer-offers__item--disabled)",
            )
            .querySelector("input").checked = true;
      } else {
        this.form.querySelector(".ps-offer-gifts")?.classList.add("hidden");
      }

      // Select the gift variant depending on the main product variant selection
      // This is only for when having a single gift
      if (
        this.gifts.length > 1 ||
        this.giftsSection?.querySelector(
          '[data-id="json-gifts-variants-mapping"]',
        ) == null
      )
        return;

      const dataVariantMatches = JSON.parse(
        this.giftsSection?.querySelector(
          '[data-id="json-gifts-variants-mapping"]',
        ).textContent,
      );

      const giftVariantRadios = this.gifts[0].querySelector(
        "gifts-variant-radios",
      );
      const variantData = JSON.parse(
        giftVariantRadios.querySelector('[type="application/json"]')
          .textContent,
      );
      const selectedVariantMatchId = dataVariantMatches[this.idInput.value];

      const variantName = variantData.find(
        (variant) => variant.id == selectedVariantMatchId,
      )?.title;
      if (!variantName) return;

      //get radio input by value equals variantName
      const giftVariantRadio = Array.from(
        giftVariantRadios.querySelectorAll("input"),
      ).filter((gift) => gift.value == variantName);
      if (giftVariantRadio.length == 0) return;
      giftVariantRadio[0].click();
    }

    updateSingleGiftSection() {
      if (
        typeof this.giftsSection.dataset.minimunOrder === "undefined" ||
        this.giftsSection.dataset.minimunOrder == 0
      )
        return;
      var giftsTitle = this.giftsSection.dataset.defaultTitle;
      const minimunOrder = this.giftsSection.dataset.minimunOrder * 1;
      var aboveMinimunOrder = this.getPreSum() > minimunOrder;

      if (aboveMinimunOrder) {
        giftsTitle = this.giftsSection.dataset.minimunOrderTitle;
        this.gifts.forEach((g) => {
          const input = g.querySelector("input");
          if (input) input.disabled = false;
        });
      } else {
        this.gifts.forEach((g) => {
          const input = g.querySelector("input");
          if (input) input.disabled = true;
        });
      }

      // We have 2 gifts title element, one for mobile and one for desktop
      this.form
        .querySelectorAll(".ps-offer-gifts__title")
        .forEach((item) => (item.innerHTML = giftsTitle));
    }

    getPreSum() {
      let sum = 0;
      this.form
        .querySelectorAll("input[name=offers]:checked")
        .forEach((item) => (sum = sum + item.dataset.price * 1));

      if (this.form.querySelector(".ps-offer__product-price-container")) {
        sum =
          sum +
          this.form.querySelector(".ps-offer__product-price-container").dataset
            .price *
            1;
      }

      const moneyNumber = parseFloat((sum / 100).toFixed(2));
      return moneyNumber;
    }

    async onAddToCart(e) {
      e.preventDefault();
      e.stopPropagation();

      this.btn.setAttribute("disabled", true);
      this.btn.innerHTML = "Loading...";

      var that = this;

      try {
        const clearResponse = await fetch("/cart/clear.js", {
          method: "POST",
        });
        if (!clearResponse.ok) return;

        var formData = new FormData(that.form);
        var data = [];

        if (formData.get("id")) {
          const productData = {
            id: formData.get("id"),
            quantity: formData.get("quantity"),
          };

          productData.properties = {};
          if (
            formData.has("checkout_property") &&
            formData.get("checkout_property") != "" &&
            formData.has("checkout_property_value") &&
            formData.get("checkout_property_value") != ""
          ) {
            const checkoutProperty = `{"${formData.get(
              "checkout_property",
            )}": "${formData.get("checkout_property_value")}"}`;
            productData.properties = JSON.parse(checkoutProperty);
          }

          productData.properties._landing_source = that.ps_source;

          if (document.getElementById(`selling-plan`) != null) {
            productData.selling_plan =
              document.getElementById(`selling-plan`).value;
          }

          let discounts = formData.get("discounts");
          discounts = discounts.split("|");

          let discountLabels = formData.get("product_discount_labels");
          discountLabels = discountLabels.split("|");

          if (discounts.length > 0 && discounts[0] != "") {
            productData.properties["_product-discount"] = discounts[0];
            productData.properties["_product-discount-label"] =
              discountLabels[0];
          }

          data.push(productData);
        }

        const gifts = formData.getAll("gifts");
        if (gifts.length > 0) {
          gifts.forEach((gift) => {
            const giftData = {
              id: gift,
              quantity: 1,
            };
            giftData.properties = {};
            if (that.form.querySelector(`[value="${gift}"]`).dataset.property) {
              giftData.properties = JSON.parse(
                that.form.querySelector(`[value="${gift}"]`).dataset.property,
              );
            }
            giftData.properties._landing_source = that.ps_source;
            data.push(giftData);
          });
        }

        if (formData.getAll("offers").length) {
          formData.getAll("offers").forEach((offer) => {
            const offerData = {
              id: offer,
              quantity: 1,
            };
            offerData.properties = {};
            if (
              that.form.querySelector(`[value="${offer}"]`).dataset.property
            ) {
              offerData.properties = JSON.parse(
                that.form.querySelector(`[value="${offer}"]`).dataset.property,
              );
            }
            offerData.properties._landing_source = that.ps_source;

            if (
              that.form.querySelector(`[value="${offer}"]`).dataset
                .sellingPlanId
            ) {
              offerData.selling_plan = JSON.parse(
                that.form.querySelector(`[value="${offer}"]`).dataset
                  .sellingPlanId,
              );
            }

            data.push(offerData);
          });
        }

        if (formData.get("multiple-products")) {
          const multipleProduct = formData.get("multiple-products");

          // look for variant radios
          const variantRadios = document.getElementById(
            `variant-radios-${multipleProduct}`,
          );

          let discounts = that.form.querySelector(
            `[value="${multipleProduct}"]`,
          ).dataset.discounts;
          discounts = discounts?.split("|") ?? [];

          let discountsLabels = that.form.querySelector(
            `[value="${multipleProduct}"]`,
          ).dataset.discountsLabels;
          discountsLabels = discountsLabels?.split("|") ?? [];

          let customKeys = that.form.querySelector(
            `[value="${multipleProduct}"]`,
          ).dataset.checkoutPropertyKeys;
          customKeys = customKeys.split("|");

          let customValues = that.form.querySelector(
            `[value="${multipleProduct}"]`,
          ).dataset.checkoutPropertyValues;
          customValues = customValues.split("|");

          if (variantRadios) {
            // get all inputs with name*=id,
            // it will hold the selected variant id
            const variantRadiosInput =
              variantRadios.querySelectorAll("[name*=id]");
            variantRadiosInput.forEach((radioInput, i) => {
              const productsData = {
                id: radioInput.value,
                quantity: 1,
              };

              if (
                document.getElementById(`selling-plan-${multipleProduct}`) !=
                null
              ) {
                productsData.selling_plan = document.getElementById(
                  `selling-plan-${multipleProduct}`,
                ).value;
              }

              productsData.properties = {};
              if (discounts.length > 0) {
                productsData.properties["_product-discount"] = discounts[i];
                productsData.properties["_product-discount-label"] =
                  discountsLabels[i];
              }
              if (customKeys.length > 0 && customValues.length > 0) {
                productsData.properties[customKeys[i]] = customValues[i];
              }
              productsData.properties._landing_source = that.ps_source;

              data.push(productsData);
            });
          } else {
            const productsData = {
              id: multipleProduct,
              quantity: that.form.querySelector(`[value="${multipleProduct}"]`)
                .dataset.qty
                ? that.form.querySelector(`[value="${multipleProduct}"]`)
                    .dataset.qty * 1
                : 1,
            };

            if (
              document.getElementById(`selling-plan-${multipleProduct}`) != null
            ) {
              productsData.selling_plan = document.getElementById(
                `selling-plan-${multipleProduct}`,
              ).value;
            }

            productsData.properties = {};
            if (discounts.length > 0) {
              productsData.properties["_product-discount"] = discounts[0];
            }
            if (customKeys.length > 0 && customValues.length > 0) {
              productsData.properties[customKeys[0]] = customValues[0];
            }
            productsData.properties._landing_source = that.ps_source;

            data.push(productsData);
          }
        }

        const addResponse = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
          },
          body: JSON.stringify({ items: data }),
        });
        if (!addResponse.ok) return;

        const addResponseJson = await addResponse.json();
        const upsellProduct = addResponseJson.items.find(
          (item) => item.product_id == that.upsell_modal,
        );
        if (that.upsell) {
          window.location = `${that.upsell}`;
        } else if (upsellProduct) {
          that.querySelector("upsell-subscription-modal").product =
            upsellProduct;
          //TODO: replace modal with a no jquery modal
          $("#ps-upsell-modal").modal(
            { backdrop: "static", keyboard: false },
            "show",
          );
        } else {
          window.location = `/checkout?${(Math.random() + 1)
            .toString(36)
            .substring(2)}`;
        }
      } finally {
        if (this.btn) {
          this.btn.removeAttribute("disabled");
          this.btn.innerHTML = "Add to Cart";
        }
      }
    }

    async onAddToCartOneTime(e) {
      e.preventDefault();
      e.stopPropagation();

      var that = this;

      const clearResponse = await fetch("/cart/clear.js", {
        method: "POST",
      });
      if (!clearResponse.ok) return;

      var formData = new FormData(that.form);
      var data = [];

      const gifts = formData.getAll("gifts");
      if (gifts.length > 0) {
        gifts.forEach((gift) => {
          const giftData = {
            id: gift,
            quantity: 1,
          };
          if (that.form.querySelector(`[value="${gift}"]`).dataset.property) {
            giftData.properties = JSON.parse(
              that.form.querySelector(`[value="${gift}"]`).dataset.property,
            );
          } else {
            giftData.properties = {};
          }
          giftData.properties._landing_source = that.ps_source;
          data.push(giftData);
        });
      }

      if (formData.getAll("offers").length) {
        formData.getAll("offers").forEach((offer) => {
          // If the offer is a one-time product,
          // we need to get the one-time product id from the data attribute
          // if that is not available, we use the offer id
          const offerData = {
            id:
              that.form.querySelector(`[value="${offer}"]`).dataset
                .oneTimeProduct &&
              that.form.querySelector(`[value="${offer}"]`).dataset
                .oneTimeProduct != ""
                ? that.form.querySelector(`[value="${offer}"]`).dataset
                    .oneTimeProduct
                : offer,
            quantity: 1,
          };
          offerData.properties = {};
          if (
            that.form.querySelector(`[value="${offer}"]`).dataset
              .oneTimeProperty
          ) {
            offerData.properties = JSON.parse(
              that.form.querySelector(`[value="${offer}"]`).dataset
                .oneTimeProperty,
            );
          }
          offerData.properties._landing_source = that.ps_source;

          if (
            that.form.querySelector(`[value="${offer}"]`).dataset
              .oneTimeAppliedDiscount
          ) {
            offerData.properties["_product-discount"] = that.form.querySelector(
              `[value="${offer}"]`,
            ).dataset.oneTimeAppliedDiscount;
          }

          data.push(offerData);
        });
      }

      const addResponse = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
        body: JSON.stringify({ items: data }),
      });
      if (!addResponse.ok) return;

      const addResponseJson = await addResponse.json();
      const upsellProduct = addResponseJson.items.find(
        (item) => item.product_id == that.upsell_modal,
      );
      if (that.upsell) {
        window.location = `${that.upsell}`;
      } else if (upsellProduct) {
        that.querySelector("upsell-subscription-modal").product = upsellProduct;
        //TODO: replace modal with a no jquery modal
        $("#ps-upsell-modal").modal(
          { backdrop: "static", keyboard: false },
          "show",
        );
      } else {
        window.location = `/checkout?${(Math.random() + 1)
          .toString(36)
          .substring(2)}`;
      }
    }

    updateKlarna() {
      if (typeof window.Klarna !== "undefined") {
        document
          .getElementsByTagName("klarna-placement")[0]
          .setAttribute(
            "data-purchase-amount",
            Math.trunc(this.getPreSum() * 100),
          );
        window.Klarna.OnsiteMessaging.refresh();
      }
    }

    updateSellingPlansVisibility(selectedElement) {
      if (this.sellingPlans.length === 0) return;
      this.sellingPlans.forEach((sp) => {
        sp.style.display = "none";
      });
      const selectedProductSellingPlans = document.getElementById(
        `selling-plans-${selectedElement.dataset.blockId}`,
      );
      if (selectedProductSellingPlans) {
        selectedProductSellingPlans.style.display = "block";
      }
    }

    updateKlarnaVisibility(selectedElement) {
      if (this.klarnaBlocks.length === 0) return;
      this.klarnaBlocks.forEach((kl) => {
        kl.style.display = "none";
      });
      const selectedProductKlarna = document.getElementById(
        `klarna-${selectedElement.dataset.blockId}`,
      );
      if (selectedProductKlarna) {
        selectedProductKlarna.style.display = "block";
      }
    }

    connectedCallback() {
      this.titleChangedUnsubscriber = subscribe(
        PUB_SUB_EVENTS.onTitleUpdate,
        (event) => {
          this.querySelector(".ps-offer__product-title").innerHTML = event.data;
        },
      );
      if (
        document.getElementById(`product-free-shipping-${this.dataset.section}`)
      ) {
        this.variantChangedUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          (event) => {
            if (event.data.variant.metafields) {
              if (event.data.variant.metafields.v2_free_shipping !== "") {
                this.footer.querySelector(
                  ".ps-offer__footer__global",
                ).textContent = event.data.variant.metafields.v2_free_shipping;
              } else {
                this.footer.querySelector(
                  ".ps-offer__footer__global",
                ).textContent = this.footer.querySelector(
                  ".ps-offer__footer__global",
                ).dataset.default;
              }

              this.footer.querySelector(
                ".ps-offer__footer__extended",
              ).textContent =
                event.data.variant.metafields.v2_free_shipping_extended;
            }
          },
        );
      }
    }

    disconnectedCallback() {
      if (this.titleChangedUnsubscriber) {
        this.titleChangedUnsubscriber();
      }

      if (this.variantChangedUnsubscriber) {
        this.variantChangedUnsubscriber();
      }
    }
  }
  customElements.define("offer-component", OfferComponent);
}

if (!customElements.get("product-variant-radios")) {
  class ProductVariantRadios extends VariantRadios {
    constructor() {
      super();

      if (
        document.getElementById(
          `product-free-shipping-${this.dataset.sectionId}`,
        )
      ) {
        const shippingContainer = document.getElementById(
          `product-free-shipping-${this.dataset.sectionId}`,
        );
        this.shippingLabel = shippingContainer.querySelector(
          ".ps-offer__footer__global",
        );
        this.shippingExtendedLabel = shippingContainer.querySelector(
          ".ps-offer__footer__extended",
        );
      }
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      const mediaGalleries = document.querySelectorAll(
        `[id^="MediaGallery-${this.dataset.gallerySectionId}"]`,
      );

      mediaGalleries.forEach((mediaGallery) => {
        const slide = mediaGallery.querySelector(
          `[data-variant-id='${this.currentVariant.featured_media.id}']`,
        );
        if (!slide) return;

        const overlayText =
          this.currentVariant.metafields?.image_overlay_text || "";
        mediaGallery
          .querySelectorAll(".variant-image-overlay")
          .forEach((overlay) => {
            overlay.textContent = "";
            overlay.hidden = true;
          });

        const overlay = slide.querySelector(".variant-image-overlay");
        if (overlay && overlayText) {
          overlay.textContent = overlayText;
          overlay.hidden = false;
        }

        mediaGallery.goToSlide(slide.dataset.slickIndex);
      });
    }

    renderProductInfo(currentInput) {
      const priceEle = document.getElementById(`price-${this.dataset.section}`);

      if (priceEle) {
        const price =
          this.currentVariant.price *
          this.currentSelectedProductElement.dataset.qty;
        const compareAtPrice =
          this.currentVariant.compare_at_price *
          this.currentSelectedProductElement.dataset.qty;
        const dataEvent = {};

        dataEvent["price"] = price;
        dataEvent["compareAtPrice"] = compareAtPrice;

        if (this.currentSelectedProductElement.dataset.discountNextPrice) {
          dataEvent["priceSuffix"] =
            this.currentSelectedProductElement.dataset.discountText;
        }
        dataEvent["sellingPlanAllocation"] =
          this.currentVariant.selling_plan_allocations[0];

        publish(PUB_SUB_EVENTS.onPriceUpdate, {
          data: dataEvent,
          target: priceEle.parentElement,
        });
      }

      const labelShade = document.getElementById(
        currentInput.dataset.labelSelected,
      );

      if (labelShade)
        labelShade.innerHTML =
          this.currentVariant[`option${currentInput.dataset.optionPosition}`];

      if (
        typeof this.shippingLabel != undefined &&
        typeof this.shippingExtendedLabel != undefined
      ) {
        if (this.currentVariant.metafields) {
          if (this.currentVariant.metafields.v2_free_shipping !== "") {
            this.shippingLabel.textContent =
              this.currentVariant.metafields.v2_free_shipping;
          } else {
            this.shippingLabel.textContent = this.shippingLabel.dataset.default;
          }

          this.shippingExtendedLabel.textContent =
            this.currentVariant.metafields.v2_free_shipping_extended;
        }
      }
    }

    toggleAddButton(disable = true, updateText = false, modifyClass = true) {
      const productForm = document.querySelector(`#${this.dataset.form}`);
      if (!productForm) return;
      const addButton = productForm.querySelector(".btn-add");
      const addButtonText = productForm.querySelector(".btn-add > span");
      if (!addButton) return;

      if (disable) {
        addButton.setAttribute("disabled", "disabled");
        if (updateText)
          addButtonText.innerHTML = addButton.getAttribute(
            "data-label-sold-out",
          );
      } else {
        addButton.removeAttribute("disabled");
        if (updateText)
          addButtonText.innerHTML = addButton.getAttribute("data-label");
      }

      if (!modifyClass) return;
    }

    setCurrentSelectedProductElement(el) {
      this.currentSelectedProductElement = el;
    }
  }

  customElements.define("product-variant-radios", ProductVariantRadios);
}

if (!customElements.get("product-radios")) {
  class ProductRadios extends HTMLElement {
    constructor() {
      super();
      this.content = document.getElementById(this.dataset.contentId);
      this.variantRadios = this.content.querySelectorAll(
        ".product-radios__variants",
      );
      this.addEventListener("change", this.onVariantChange);

      this.currentSelectedElement = this.querySelector(
        'input[name="multiple-products"]:checked',
      );
      this.currentProductVariants = this.getProductData(
        this.currentSelectedElement,
      );
      this.productId = this.currentSelectedElement.dataset.productId;
    }

    onVariantChange(e) {
      if (e.target.name == "multiple-products") {
        this.updateMasterId(e.target);

        if (this.dataset.updateInfo === "true") {
          this.renderProductInfo();
          this.updateMedia();
        }
        this.updateVariantRadios();

        e.currentTarget.dispatchEvent(
          new CustomEvent("variantChange", {
            detail: { selectedOption: this.currentSelectedElement },
          }),
        );
      }
    }

    updateMasterId(target) {
      this.currentProductVariants = this.getProductData(target);
      this.currentSelectedElement = target;
      this.productId = target.dataset.productId;
    }

    getProductData(target) {
      return JSON.parse(
        target.parentElement.querySelector('[type="application/json"]')
          .textContent,
      );
    }

    renderProductInfo() {
      const priceEle = document.getElementById(`price-${this.dataset.section}`);
      const priceSubscriptionCopy = priceEle.querySelector(
        ".price-subscription-copy",
      );

      const price = this.currentSelectedElement.dataset.price * 1;
      const compareAtPrice =
        this.currentSelectedElement.dataset.compareAtPrice * 1;
      const dataEvent = {};

      if (priceEle) {
        dataEvent["price"] = price;
        dataEvent["compareAtPrice"] = compareAtPrice;
      }

      if (this.currentSelectedElement.dataset.discountNextPrice) {
        dataEvent["priceSuffix"] =
          this.currentSelectedElement.dataset.discountText;
      }

      if (this.currentProductVariants[0].selling_plan_allocations.length > 0) {
        dataEvent["sellingPlanAllocation"] =
          this.currentProductVariants[0].selling_plan_allocations[0];
      }

      if (this.currentSelectedElement.dataset.showPriceSubscription == "true") {
        priceSubscriptionCopy.style.setProperty("display", "");
      } else {
        priceSubscriptionCopy.style.setProperty("display", "none");
      }

      publish(PUB_SUB_EVENTS.onPriceUpdate, {
        data: dataEvent,
        target: priceEle.parentElement,
      });

      if (typeof this.currentSelectedElement.dataset.title !== "undefined") {
        publish(PUB_SUB_EVENTS.onTitleUpdate, {
          data: this.currentSelectedElement.dataset.title,
        });
      }
    }

    updateMedia() {
      if (!this.currentProductVariants) return;

      const mediaGalleries = document.querySelectorAll(
        `[id^="Multiproduct-Slider-Gallery-${this.dataset.section}"]`,
      );

      mediaGalleries.forEach((mediaGallery) => {
        mediaGallery.classList.remove("active");
      });

      const activeMedia = document.querySelector(
        `[id="Multiproduct-Slider-Gallery-${this.dataset.section}-${this.currentSelectedElement.dataset.blockId}"]`,
      );
      activeMedia.classList.add("active");

      activeMedia.querySelector(".ps-single-offer__gallery-main").rebuild();
    }

    updateVariantRadios() {
      this.variantRadios.forEach((variantRadio) => {
        variantRadio.style.display = "none";
      });
      const selectedProductvariantRadios = document.getElementById(
        `variant-radios-${this.currentSelectedElement.dataset.blockId}`,
      );
      if (selectedProductvariantRadios) {
        selectedProductvariantRadios.style.display = "block";

        // Set the current selected product element to the radios
        // so we can update the product info when the variant changes
        selectedProductvariantRadios
          .querySelectorAll("product-variant-radios")
          .forEach((radios) => {
            radios.setCurrentSelectedProductElement(
              this.currentSelectedElement,
            );
          });
      }
    }
  }

  customElements.define("product-radios", ProductRadios);
}

document.querySelectorAll('a[href="#offer"]').forEach((anchor) => {
  anchor.addEventListener("click", function (e) {
    e.preventDefault();

    function scrollToOffer() {
      const offerElement = document.getElementById("offer");
      const header = document.querySelector(
        "sticky-header .shopify-section-header-sticky",
      );
      let headerHeight = 0;
      if (header && window.getComputedStyle(header).position === "fixed") {
        headerHeight = header.offsetHeight;
      }
      if (offerElement) {
        const yPosition =
          offerElement.getBoundingClientRect().top +
          window.scrollY -
          headerHeight;
        window.scrollTo({ top: yPosition });
      }
    }

    // Recalculate position just before scrolling
    scrollToOffer();

    // Optionally, recalculate while scrolling for dynamic headers
    let scrollTimeout;
    window.addEventListener(
      "scroll",
      function () {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => {
          scrollToOffer();
        }, 100);
      },
      { once: true },
    );
  });
});
